import { MAX_CLIP_ID_LENGTH } from 'helpers/constants';
import { clipPattern } from './constants';

export const isInvalidClipId = (id: string): boolean => id.length > MAX_CLIP_ID_LENGTH || !clipPattern.test(id);
